import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useAuthContext } from '../../../context/AuthContextProvider';
import { PostsContextProvider } from '../../../context/PostsProvider';
import { BirthdaysComponent } from '../../../sections/@dashboard/BirthdaysComponent/BirthdaysComponent';
import { CreateEditPostModal } from '../../../sections/@dashboard/CreateEditPostModal/CreateEditPostModal';
import { NewPostCard } from '../../../sections/@dashboard/NewPostCard/NewPostCard';
import { TimelineComponent } from '../../../sections/@dashboard/Timeline/Timeline';

export const FeedPage = () => {
  const { user } = useAuthContext();
  const [showModal, setShowModal] = useState(false);

  const INTRANET_ADMIN = user?.adm_intranet == 'S';

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <PostsContextProvider>
      <Grid container spacing={4}>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Card sx={{ p: 2 }}>
            <Stack spacing={1}>
              <Typography variant="h4" component="h1">
                Olá {user?.nome}
              </Typography>
              <Typography variant="h5" component="h2">
                Bem-vindo a intranet Resfri Ar
              </Typography>
              <Typography variant="body1">
                Aqui você encontra as últimas novidades da empresa, suas folhas de pagamento e demais informações importantes para o seu dia
                a dia de trabalho.
              </Typography>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          {INTRANET_ADMIN && (
            <Box sx={{ mb: 2 }}>
              <NewPostCard showPostModal={handleOpenModal} />
            </Box>
          )}
          <Box>
            <TimelineComponent />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <BirthdaysComponent />
        </Grid>
      </Grid>
      <CreateEditPostModal open={showModal} onClose={handleCloseModal} />
    </PostsContextProvider>
  );
};
